export default "__VITE_ASSET__QOtUbrCR__"